<template>
	<div class="shop-index-page">
		
		<!-- ====== Banner区域 ====== -->
		<div class="hero-section animate__animated animate__fadeIn">
			<el-image class="hero-bg-img" :src="require('@/static/CodeBuddyAssets/30818_2772/41.png')" fit="cover"></el-image>
			<div class="hero-inner">
				<!-- 标题区 -->
				<div class="hero-title-section">
					<h1 class="hero-main-title">国淘精品更便宜，跨境物流更便捷</h1>
					<div class="hero-main-title2 f-ct">
						<div class="hero-decoration-line left-line"></div>
						<p class="hero-sub-title">下单&nbsp;商家发货&nbsp;提交包裹&nbsp;等待签收包裹</p>
						<div class="hero-decoration-line right-line"></div>
					</div>
				</div>
				<!-- 搜索与购物车 -->
				<div class="hero-search-area">
					<div class="search-box">
						<el-input class="search-input" placeholder="请在此处输入您想查询的商品名称或商品链接" v-model="searchKeyword"></el-input>
						<div class="search-btn" @click="sousuoSubmit">搜索</div>
					</div>
					<div class="cart-btn" @click="link('/shopCar')">
						<span class="cart-count" v-if="cartNub">{{cartNub}}</span>
						<span class="cart-text">我的购物车</span>
						<el-image class="cart-arrow" :src="require('@/static/CodeBuddyAssets/30818_2772/5.svg')"></el-image>
					</div>
				</div>
			</div>
		</div>
		
		<!-- 类型筛选 -->
		<div class="goodsType">
			<div class="item" :class="gtype == 1?'aitem':''" @click="changeNav(1)">自营</div>
			<div class="item" :class="gtype == 2?'aitem':''" @click="changeNav(2)">1688</div>
			<div class="item" :class="gtype == 3?'aitem':''" @click="changeNav(3)">淘宝</div>
			<div class="item" :class="gtype == 4?'aitem':''" @click="changeNav(4)">京东</div>
		</div>
		
		<!-- ====== 功能卡片区 ====== -->
		<div class="feature-section animate__animated animate__fadeInUp">
			<div class="feature-cards-wrapper">
				<!-- 提交代购 -->
				<div class="feature-card card-submit">
					<div class="fc-title">提交代购</div>
					<div class="fc-desc">一站式边界下单</div>
					<el-image class="fc-icon" :src="require('@/static/CodeBuddyAssets/30818_2772/12.svg')"></el-image>
					<el-image class="fc-bg-deco" :src="require('@/static/CodeBuddyAssets/30818_2772/11.svg')"></el-image>
				</div>
				<!-- 商品分类 -->
				<div class="feature-card card-category" @click="link('/shopCat')">
					<div class="fc-title">商品分类</div>
					<div class="fc-desc">众多分类都在这</div>
					<el-image class="fc-icon" :src="require('@/static/CodeBuddyAssets/30818_2772/14.svg')"></el-image>
					<el-image class="fc-bg-deco" :src="require('@/static/CodeBuddyAssets/30818_2772/13.svg')"></el-image>
				</div>
				<!-- 领券中心 -->
				<div class="feature-card card-coupon" @click="link('/userPageLab/myCoupon')">
					<div class="fc-title">领券中心</div>
					<div class="fc-desc">快来领取折扣吧</div>
					<el-image class="fc-icon" :src="require('@/static/CodeBuddyAssets/30818_2772/16.svg')"></el-image>
					<el-image class="fc-bg-deco" :src="require('@/static/CodeBuddyAssets/30818_2772/15.svg')"></el-image>
				</div>
				<!-- 新品上市 -->
				<div class="feature-card card-new">
					<div class="fc-title">新品上市</div>
					<div class="fc-price-row">
						<div class="fc-price" @click="link('/shopMsg',{id:item.id,channelType:1})" v-if="index<2" v-for="(item,index) in newGoodsList">
							<el-image :src="item.picUrl"></el-image>
							<span class="fc-price-txt">￥{{item.retailPrice}}</span>
						</div>
					</div>
				</div>
				<!-- 好物推荐 -->
				<div class="feature-card card-good">
					<div class="fc-title">好物推荐</div>
					<div class="fc-price-row">
						<div class="fc-price" @click="link('/shopMsg',{id:item.id,channelType:1})" v-if="index<2" v-for="(item,index) in hotGoodsList">
							<el-image :src="item.picUrl"></el-image>
							<span class="fc-price-txt">￥{{item.retailPrice}}</span>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- ====== 商品列表 ====== -->
		<div class="product-section animate__animated animate__fadeInUp">
			<div class="product-grid-wrapper">
				<!-- 暂无 -->
				<div class="zwBox" style="width: 100%;" v-if="!productList.length">
					<el-image :src="require('@/static/zw.svg')"></el-image>
					<p>暂无商品数据</p>
				</div>
				<div class="product-card" @click="link('/shopMsg',{id:item.item_id,channelType:gtype})" v-for="(item, index) in productList" :key="index">
					<el-image class="product-img" :src="item.main_image_url" :preview-src-list="[item.main_image_url]" fit="cover"></el-image>
					<div class="product-name line2">
						<span class="product-tag tag-blue" v-if="gtype==1">自营</span>
						<span class="product-tag tag-red" v-if="gtype==2">1688</span>
						<span class="product-tag tag-orange" v-if="gtype==3">淘宝</span>
						<span class="product-tag tag-red" v-if="gtype==4">京东</span>
						<span class="product-name1">&nbsp;{{ item.title }}</span>
					</div>
					<div class="product-bottom">
						<span class="product-price">
							<span class="price-symbol">￥</span>
							<span class="price-value">{{ item.price }}</span>
						</span>
						<span class="product-sales">{{ item.salesCount }}人付款</span>
					</div>
				</div>
			</div>
		</div>

		<!-- ====== 分页 ====== -->
		<div v-if="productList.length" class="pagination-wrap animate__animated animate__fadeInUp">
			<el-pagination
				background
				layout="prev, pager, next, jumper"
				:total="total"
				:page-size="pageSize"
				:current-page.sync="currentPage"
				@current-change="handleCurrentChange">
			</el-pagination>
		</div>
		
	</div>
</template>

<script>
import {
	homeindex,
	cartcount,
	goodslist,
	goodsdetail
} from "/src/api/api.js"
export default {
	name: 'ShopIndex',
	data() {
		return {
			linkPlink: '',
			searchKeyword: '',
			currentPage: 1,
			pageSize: 20,
			total: 80,
			// 商品列表
			productList: [],
			// 好物推荐
			hotGoodsList:[],
			// 新品上市
			newGoodsList:[],
			// 购物车数量
			cartNub:0,
			// 列表类型
			gtype:1,
		}
	},
	mounted() {
		if(this.$route.query.channelType){
			this.gtype = this.$route.query.channelType*1
		}
		if(this.$route.query.linkPlink){
			this.linkPlink = this.$route.query.linkPlink
		}
		this.homeindexGet()
		this.cartcountGet()
		this.goodslistGet()
	},
	methods: {
		// 商品列表
		async goodslistGet(){
			var res;
			var data = {
				pageNum: this.currentPage,
				pageSize: this.pageSize,
				channelType:this.gtype*1,
				keyword:this.searchKeyword,
			}
			if(this.linkPlink){
				data.picUrl = this.linkPlink
			}
			res = await goodslist(data);
			if(res.code==200){
				this.total = res.total
				this.productList = res.rows
			}else{this.Tips(res.msg,'error')}
		},
		// 搜索点击
		async sousuoSubmit(){
			if(this.gtype*1!=1){
				// 搜索详情
				const res = await goodsdetail({itemUrl:this.searchKeyword,channelType:this.gtype*1,})
				if(res.code==200){
					if(res.data){
						this.link('/shopMsg',{itemUrl:this.searchKeyword,channelType:this.gtype*1})
					}else{
						// 刷新数据
						this.currentPage = 1
						this.goodslistGet()
					}
				}else{this.Tips(res.msg,'error')}
			}else{
				// 刷新数据
				this.currentPage = 1
				this.goodslistGet()
			}
		},
		// 切换nav
		changeNav(gtype){
			this.gtype = gtype
			this.currentPage = 1
			this.goodslistGet()
		},
		// 分页
		handleCurrentChange(page) {
			this.currentPage = page
			this.goodslistGet()
		},
		// 跳转至资讯详情页
		goToDetail(item) {
			this.link('/shopDetail', { id: item.id })
		},
		// 获取代购首页信息
		async homeindexGet(){
			var res;
			res = await homeindex({});
			if(res.code==200){
				this.hotGoodsList = res.data.hotGoodsList
				this.newGoodsList = res.data.newGoodsList
			}else{this.Tips(res.msg,'error')}
		},
		// 购物车数量
		async cartcountGet(){
			var res;
			res = await cartcount({});
			if(res.code==200){
				this.cartNub = res.data
			}else{this.Tips(res.msg,'error')}
		},
	}
}
</script>

<style lang="scss" scoped>
.shop-index-page {
	width: 100%;
	min-height: 100vh;
	background: #fff;
}

/* ===================================================================
   Banner区域
   =================================================================== */
.hero-section {
	width: 100%;
	height: 365px;
	background: #0096FF;
	overflow: hidden;
	position: relative;
}
.hero-bg-img {
	width: 100%;
	height: 365px;
	display: block;
}
.hero-inner {
	margin-top: -365px;
	position: relative;
	z-index: 1;
}

/* 顶部导航 */
.hero-nav {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 22px 90px 0 90px;
	height: 38px;
}
.hero-nav-left {
	display: flex;
	align-items: center;
}
.hn-item {
	color: rgba(255, 255, 255, 0.85);
	font-size: 16px;
	font-weight: 500;
	cursor: pointer;
	padding: 0 12px;
	line-height: 34px;
	margin-right: 24px;
	transition: color 0.3s;
	white-space: nowrap;
}
.hn-item:hover {
	color: #fff;
}
.hn-item.hn-active {
	color: #fff;
	position: relative;
}
.hn-item.hn-active::after {
	content: '';
	position: absolute;
	bottom: -4px;
	left: 50%;
	transform: translateX(-50%);
	width: 20px;
	height: 2px;
	background: #fff;
	border-radius: 1px;
}
.hero-nav-right {
	display: flex;
	align-items: center;
}
.hn-lang {
	color: rgba(255, 255, 255, 0.85);
	font-size: 16px;
	font-weight: 500;
	cursor: pointer;
	margin-right: 4px;
}
.hn-icon {
	width: 16px;
	height: 16px;
	margin: 0 6px;
}
.hn-user {
	color: rgba(255, 255, 255, 0.85);
	font-size: 16px;
	font-weight: 500;
	margin-left: 4px;
	margin-right: 6px;
}
.hn-logout {
	color: rgba(255, 255, 255, 0.85);
	font-size: 16px;
	font-weight: 500;
	cursor: pointer;
	margin-left: 6px;
}

/* 标题区 */
.hero-title-section {
	text-align: center;
	padding-top: 100px;
	position: relative;
}
.hero-main-title {
	font-size: 62px;
	font-weight: 600;
	font-family: 'PingFang SC', sans-serif;
	color: #fff;
	margin: 0;
	white-space: nowrap;
	display: inline-block;
}
.hero-main-title2{
	justify-content: center;
	margin: 15px 0 0 0;
}
.hero-sub-title {
	font-size: 20px;
	font-weight: 500;
	font-family: 'PingFang SC', sans-serif;
	color: #fff;
	margin: 0 24px;
}
.hero-decoration-line {
	width: 82px;
	height: 2px;
}
.left-line {
	background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #fff 100%);
}
.right-line {
	background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #fff 100%);
}

/* 搜索与购物车 */
.hero-search-area {
	display: flex;
	justify-content: center;
	align-items: center;
	padding-top: 38px;
}
.search-box {
	width: 1004px;
	height: 54px;
	background: #fff;
	border-radius: 8px;
	display: flex;
	align-items: center;
	overflow: hidden;
}
.search-input {
	flex: 1;
	height: 54px;
}
.search-input ::v-deep .el-input__inner {
	border: none;
	height: 54px;
	line-height: 54px;
	font-size: 14px;
	padding-left: 24px;
	color: #333;
	background: transparent;
	box-shadow: none;
}
.search-input ::v-deep .el-input__inner::placeholder {
	color: #B2B0AA;
}
.search-btn {
	width: 92px;
	height: 54px;
	background: #00315C;
	color: #fff;
	font-size: 14px;
	text-align: center;
	line-height: 54px;
	cursor: pointer;
	border-top-right-radius: 8px;
	border-bottom-right-radius: 8px;
	flex-shrink: 0;
}
.cart-btn {
	width: 142px;
	height: 54px;
	background: #F9F9F9;
	border: 1px solid #ECECEC;
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-left: 16px;
	cursor: pointer;
	position: relative;
}
.cart-icon {
	width: 18px;
	height: 18px;
}
.cart-count {
	position: absolute;
	top: 7px;
	left: 110px;
	padding: 0 4px;
	padding-left: 5px;
	height: 18px;
	background: #FC3C3C;
	border-radius: 50%;
	color: #fff;
	font-size: 12px;
	text-align: center;
	line-height: 18px;
	z-index: 2;
}
.cart-text {
	font-size: 14px;
	color: #333;
	margin: 0 4px;
}
.cart-arrow {
	width: 18px;
	height: 18px;
}

// 类型筛选
.goodsType{
	width: 1274px;
	margin: auto;
	display: flex;
	flex-wrap: nowrap;
	margin-top: 24px;
	padding-left: 12px;
	.item{
		color: #B2B0AA;
		font-size: 18px;
		margin-right: 52px;
		position: relative;
		padding-bottom: 8px;
		cursor: pointer;
		&::after{
			position: absolute;
			content: '';
			width: 0px;
			height: 2px;
			border-radius: 2px;
			background: #00315C;
			bottom: 0;
			left: 50%;
			transform: translateX(-50%);
			transition:0.3s;
		}
	}
	.aitem{
		color: #333333;
		font-weight: bold;
		&::after{
			width: 26px;
			transition:0.3s;
		}
	}
}

/* ===================================================================
   功能卡片区
   =================================================================== */
.feature-section {
	padding: 24px 0;
	display: flex;
	justify-content: center;
}
.feature-cards-wrapper {
	width: 1274px;
	display: flex;
	flex-wrap: nowrap;
}
.feature-card {
	width: 234px;
	height: 120px;
	border-radius: 8px;
	margin-right: 26px;
	padding: 16px 16px;
	box-sizing: border-box;
	position: relative;
	overflow: hidden;
	flex-shrink: 0;
}
.feature-card:last-child {
	margin-right: 0;
}

/* 提交代购 - 蓝色渐变 */
.card-submit {
	background: linear-gradient(135deg, #49A1FF 0%, #6EDFFF 100%);
}
/* 商品分类 - 橙色渐变 */
.card-category {
	background: linear-gradient(135deg, #FF823B 0%, #FFB055 100%);
}
/* 领券中心 - 红色渐变 */
.card-coupon {
	background: linear-gradient(135deg, #FE4F4F 0%, #FF8D64 100%);
}
/* 新品上市 */
.card-new {
	background: linear-gradient(180deg, #FFF2E2 0%, #fff 100%);
	background: #F7F7F7;
}
/* 好物推荐 */
.card-good {
	background: #F7F7F7;
}

.fc-title {
	font-size: 16px;
	font-weight: 500;
	color: #333;
	position: relative;
	z-index: 1;
}
.card-submit .fc-title,
.card-category .fc-title,
.card-coupon .fc-title {
	color: #fff;
	font-size: 18px;
	font-weight: 600;
}
.card-submit .fc-title {
	font-weight: 600;
}
.card-category .fc-title,
.card-coupon .fc-title {
	font-weight: 500;
}
.fc-desc {
	font-size: 14px;
	color: #333;
	margin-top: 8px;
	position: relative;
	z-index: 1;
}
.card-submit .fc-desc,
.card-category .fc-desc,
.card-coupon .fc-desc {
	color: #fff;
}
.fc-icon {
	position: absolute;
	bottom: 20px;
	left: 20px;
	z-index: 1;
}
.fc-bg-deco {
	position: absolute;
	bottom: 20px;
	right: 8px;
}

.fc-price-row {
	display: flex;
	margin-top: 10px;
	position: relative;
	// justify-content: space-between;
	z-index: 1;
}
.fc-price {
	width: calc(90% / 3);
	margin-right: 8px;
	.el-image{
		width: 52px;
		height: 52px;
		border: 1px solid #eee;
		border-radius: 12px;
		margin: auto;
		background: #fff;
		display: block;
	}
}
.fc-price:last-child {
	margin-right: 0;
}
.fc-price-txt {
	font-size: 12px;
	font-weight: 500;
	color: #fff;
	background: #FF5000;
	width: 90%;
	padding: 1px;
	border-radius: 4px;
	display: block;
	text-align: center;
	margin: auto;
	transform: translateY(-10px);
}

/* ===================================================================
   商品列表
   =================================================================== */
.product-section {
	display: flex;
	justify-content: center;
	padding-top: 20px;
	padding-bottom: 10px;
}
.product-grid-wrapper {
	width: 1274px;
	display: flex;
	flex-wrap: wrap;
}
.product-card {
	width: 238px;
	height: 326px;
	margin-right: 21px;
	margin-bottom: 12px;
	position: relative;
}
.product-card:nth-child(5n) {
	margin-right: 0;
}
.product-img {
	width: 238px;
	height: 238px;
	border-radius: 10px;
	display: block;
	cursor: pointer;
}
.product-tag {
	border-radius: 3px;
	font-size: 12px;
	font-weight: 400;
	padding: 0px 4px;
	display: inline-block;
}
.tag-orange {
	border: 1px solid #FF7120;
	background: #FFF5E9;
	color: #FF7120;
}
.tag-red {
	border: 1px solid #FC3C3C;
	background: #FFE9E9;
	color: #FC3C3C;
}
.tag-blue {
	border: 1px solid #0096FF;
	background: #E9F5FF;
	color: #0096FF;
}
.product-name{
	margin-top: 6px;
	text-align: justify;
	// line-height: 24px;
}
.product-name1 {
	font-size: 14px;
	font-weight: 500;
	color: #333;
	display: inline;
}
.product-bottom {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 10px;
	padding-left: 4px;
}
.product-price {
	color: #FC3C3C;
	display: inline-flex;
	align-items: baseline;
}
.price-symbol {
	font-size: 12px;
	font-weight: 500;
	font-family: 'MiSans', sans-serif;
}
.price-value {
	font-size: 18px;
	font-weight: 600;
	font-family: 'MiSans', sans-serif;
}
.product-sales {
	font-size: 12px;
	color: #999;
	font-weight: 400;
	text-align: right;
}

/* ===================================================================
   分页器
   =================================================================== */
.pagination-wrap {
	display: flex;
	justify-content: center;
	padding: 30px 0 60px;
	::v-deep .el-pagination {
		font-weight: 400;
		.el-pager li {
			min-width: 32px;
			height: 32px;
			line-height: 32px;
			font-size: 14px;
			border-radius: 4px;
			margin: 0 2px;
			color: #333;
			&.active {
				background: #0096FF;
				color: #fff;
				border-color: #0096FF;
			}
			&:hover {
				color: #0096FF;
			}
		}
		.el-pagination__total {
			font-size: 14px;
			color: #999;
			margin-right: 12px;
		}
		.btn-prev, .btn-next {
			min-width: 32px;
			height: 32px;
			line-height: 32px;
			font-size: 14px;
			border-radius: 4px;
			&:hover { color: #0096FF; }
		}
		.el-pagination__jump {
			font-size: 14px;
			color: #999;
			margin-left: 12px;
			.el-input__inner {
				width: 50px;
				height: 32px;
				line-height: 32px;
				font-size: 14px;
				border-radius: 4px;
				&:focus { border-color: #0096FF; }
			}
		}
	}
	::v-deep .el-pagination.is-background .el-pager li{
		background: transparent;
	}
	::v-deep .el-pagination.is-background .btn-prev{
		background: transparent;
	}
	::v-deep .el-pagination.is-background .btn-next{
		background: transparent;
	}
}
</style>
